import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TechnicianService } from '../../../../services/technician.service';
import { PosIntegrationService } from '../../../../services/pos-integration.service';
import { ProductsService } from '../../../../services/products.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { AppConfig } from '../../../../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoPlayerComponent } from '../../../modals/video-player/video-player.component';

@Component({
  selector: 'app-quick-launch',
  templateUrl: './quick-launch.component.html',
  styleUrls: ['./quick-launch.component.scss'],
})
export class QuickLaunchComponent implements OnInit {
  public partner: any = this.helpersService.getPartnerData();
  public partnerID: any = this.helpersService.getPartnerId();

  public checklistConfig: any = [];
  public activeChecklistConfig = 0;
  public checklistConfigConfigured = -1;
  public serviceTypes: any = [];
  public activeServiceTypes = 0;
  public serviceTypesConfigured = -1;
  public messageTemplates: any = [];
  public activeMessageTemplates = 0;
  public messageTemplatesConfigured = -1;
  public technicians: any = [];
  public activeTechnicians = 0;
  public techniciansConfigured = -1;
  public cyclists: any = [];
  public users: any = [];
  public cyclistsConfigured = -1;
  public jobCardConfigured = -1;
  public posConfigured = -1;
  public posProducts = -1;
  public busyServiceTypes: boolean = false;
  public techniciansBusy: boolean = false;
  public busyMessages: boolean = false;
  public busyCyclists: boolean = false;
  public busyPosProducts: boolean = false;

  public chartColor1 = '#0F4C81';
  public chartColor2 = '#1976d2';
  public chartColor3 = '#619371';
  public chartColor4 = '#ff4e07';
  public chartColor5 = '#fbc02d';

  public messages: any = [
    { index: 1, key: 'bike.sale', value: 'Bike Sale' },
    { index: 2, key: 'user.welcome', value: 'Welcome Message' },
    { index: 3, key: 'service.bookin', value: 'Bike Booked In' },
    { index: 4, key: 'service.schedule', value: 'Job Scheduled' },
    { index: 5, key: 'service.assign', value: 'Waiting for Work' },
    { index: 6, key: 'service.start', value: 'Job Started' },
    { index: 6, key: 'service.warranty', value: 'Warranty Job Started' },
    { index: 7, key: 'service.waitingforclient', value: 'Waiting for Client' },
    { index: 8, key: 'service.waitingforparts', value: 'Waiting for Parts' },
    { index: 9, key: 'service.collected', value: 'Bike Collected' },
    { index: 10, key: 'service.complete', value: 'Job Completed' },
  ];
  public overviewActionTypes = {
    USERS: 1,
    SERVICE_TYPES: 2,
    MESSAGE_TEMPLATES: 3,
    POS_CONFIG: 4,
    CUSTOMERS: 5,
  };

  constructor(
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private technicianService: TechnicianService,
    private posIntegrationService: PosIntegrationService,
    private cyclistService: CyclistService,
    private productsService: ProductsService,
    public router: Router,
    public modalService: NgbModal,
    private appConfig: AppConfig,
  ) {}

  ngOnInit() {
    this.getTechnicians();
    this.getPOSConfiguration();
    this.getChecklistConfig();
    this.getServiceTypes();
    this.getMessageTemplates();
    this.getCyclists();
    this.getProducts();
  }

  getProducts() {
    this.busyPosProducts = true;
    this.productsService
      .getAllProducts(this.helpersService.getPartnerId())
      .subscribe((products) => {
        this.helpersService.saveProductData(products);
        this.posProducts = this.helpersService.getProductData().length;
        this.busyPosProducts = false;
      });
  }

  getChecklistConfig() {
    this.partnerService
      .getChecklistConfigAll(this.partnerID)
      .subscribe((checklist) => {
        this.checklistConfig = checklist;
        this.checklistConfigConfigured =
          checklist.filter((x) => {
            return x.IsActive === true;
          }).length > 0
            ? 1
            : 0;
        this.activeChecklistConfig = checklist.filter((x) => {
          return x.IsActive === true;
        }).length;
      });
  }

  getServiceTypes() {
    this.busyServiceTypes = true;
    this.partnerService
      .getPartnerServiceTypesFull(this.partnerID)
      .subscribe((serviceTypes) => {
        this.serviceTypes = serviceTypes;
        this.serviceTypesConfigured =
          serviceTypes.filter((x) => {
            return x.IsActive === true;
          }).length > 0
            ? 1
            : 0;
        this.activeServiceTypes = serviceTypes.filter((x) => {
          return x.IsActive === true;
        }).length;
        this.busyServiceTypes = false;
      });
  }

  getMessageTemplates() {
    this.busyMessages = true;
    this.messageTemplates = [];
    this.partnerService
      .getMessageTemplates(this.partnerID)
      .subscribe((messageTemplates) => {
        this.messageTemplatesConfigured =
          messageTemplates.filter((x) => {
            return x.IsActive === true;
          }).length > 0
            ? 1
            : 0;
        this.activeMessageTemplates = messageTemplates.filter((x) => {
          return x.IsActive === true;
        }).length;

        messageTemplates.forEach((message) => {
          var tmp = this.messages
            .filter((x) => {
              return x.key === message.EventTag;
            })
            .pop();
          tmp = { ...tmp, ...message };
          this.messageTemplates.push(tmp);
        });
        this.busyMessages = false;
      });
  }

  getCyclists() {
    this.busyCyclists = true;
    this.partnerService.getPartnerUsers(this.partnerID).subscribe((users) => {
      this.cyclistService
        .searchCyclist(this.partnerID, '')
        .subscribe((cyclists) => {
          this.users = users;
          var user_ids = this.users.map((x) => {
            return x.ID;
          });
          this.cyclists = cyclists.filter((x) => {
            return !user_ids.includes(x.ID);
          });
          this.cyclistsConfigured = this.cyclists.length > 0 ? 1 : 0;
          this.busyCyclists = false;
        });
    });
  }

  async getTechnicians() {
    this.techniciansBusy = true;
    this.partnerService
      .getPartnerTechnicians(this.partnerID)
      .subscribe((technicians) => {
        this.activeTechnicians = technicians.filter((x) => {
          return x.IsActive === true;
        }).length;
        if (this.technicians.length === 0) {
          this.techniciansConfigured = 0;
          this.techniciansBusy = false;
        }
        technicians.forEach((technician, index, array) => {
          this.technicianService
            .getTechnicianWorkHours(technician.ID)
            .subscribe((workHours) => {
              technician = { ...workHours, ...technician };
              this.technicians.push(technician);
              if (
                technician.IsActive &&
                (workHours.MondayStart ||
                  workHours.MondayStart ||
                  workHours.WednesdayStart ||
                  workHours.ThursdayStart ||
                  workHours.FridayStart)
              ) {
                this.techniciansConfigured = 1;
              }
              if (index === array.length) {
                setTimeout(() => {
                  this.techniciansConfigured =
                    this.techniciansConfigured === 1 ? 1 : 0;
                  this.techniciansBusy = false;
                }, 1000);
              }
            });
        });
      });
  }

  getPOSConfiguration() {
    if (this.partner.POSSystemID > 0) {
      this.posIntegrationService
        .checkPOSIntegration(this.partnerID, this.partner.POSSystemID)
        .subscribe(
          (pos) => {
            this.posConfigured = 1;
          },
          (err) => {
            this.posConfigured = 0;
          },
        );
    } else {
      this.posConfigured = 0;
    }
  }

  tutorialAction(event) {
    var tutorial = this.appConfig
      .getTutorialVideos()
      .filter((x) => {
        return x.type === event.type;
      })
      .pop();
    if (tutorial) {
      const modalRef = this.modalService.open(VideoPlayerComponent, {
        size: 'lg',
        backdrop: 'static',
      });
      modalRef.componentInstance.tutorial = tutorial;
      modalRef.result.then(
        (result) => {},
        (onrejected) => {},
      );
    }
  }

  overviewAction(event) {
    if (event.type === this.overviewActionTypes.SERVICE_TYPES) {
      this.goToServiceTypes();
    } else if (event.type === this.overviewActionTypes.USERS) {
      this.goToUsers();
    } else if (event.type === this.overviewActionTypes.MESSAGE_TEMPLATES) {
      this.goToMessageTemplates();
    } else if (event.type === this.overviewActionTypes.CUSTOMERS) {
      this.goToCyclists();
    } else if (event.type === this.overviewActionTypes.POS_CONFIG) {
      this.goToShopProfile();
    }
  }

  goToMessageTemplates() {
    this.router.navigateByUrl('/store/message-templates');
  }

  goToServiceTypes() {
    this.router.navigateByUrl('/store/service-types');
  }

  goToUsers() {
    this.router.navigateByUrl('/store/users');
  }

  goToCyclists() {
    this.router.navigateByUrl('/store/cyclists');
  }

  goToShopProfile() {
    this.router.navigateByUrl('/store/shop-profile');
  }
}
